<template>
	<div :class="{folderBorder:root&&!expand, folderExpand:expand}"
		style="border-top:1px solid transparent">
		<div class="dy-folder-item" @click.stop="onClick(fid, level)">
			<div :class="'folder-name'">
				<dy-icon 
					icon="icon-folder-close-filled"
					:tooltip="data.name"
					:class="{iconActive:fid==active}"></dy-icon>
				<span v-if="!editable">{{data.name}}
					<dy-icon class="folder-rename"
						icon="icon-edit" 
						tooltip="修改名称"
						@click.stop="editable=true"></dy-icon>
				</span>
					
				<dy-input v-else
					type="text" 
					class="folder-name-input" 
					:maxlength="16" 
					:number="false" 
					:clear="false"
					:focus="editable"
					v-model="data.name"
					@blur="editable=false"
					@input="update(fid, data.name)"
					@mousedown.stop 
					@mousemove.stop
					@mouseup.stop
					@click.stop/>	
			</div>
			<dy-icon 
				:class="{iconExpand:expand}"
				icon="icon-up" 
				tooltip="收起/展开" 
				v-if="data.children && Object.keys(data.children).length>0"
				@click.stop="expand=!expand"></dy-icon>
				
			<dy-icon
				icon="icon-delete" 
				tooltip="删除"
				v-else
				@click.stop="onRemove(fid, data.name)"></dy-icon>
		</div>
		<editor-folder-item v-for="(item,key) in data.children" 
			:style="{paddingLeft:data.children?'8px':''}"
			:fid="key"
			:data="item"
			:root="false"
			:level="level+1"
			:active="active"
			@clickItem="itemClick"
			@removeItem="onRemove"
			v-if="expand"></editor-folder-item>
	</div>
</template>

<script>
	export default {
		name:"dy-folder-item",
		props:{
			fid:{
				type:String,
				default:'',
			},
			data:{
				type:Object,
				default:{},
			},
			root:{
				type:Boolean,
				default:true,
			},
			level:{
				type:Number,
				default:0,
			},
			active:{
				type:String,
				default:'',
			}
		},
		data() {
			return {
				expand:false,
				editable:false,
			};
		},
		methods:{
			update(fid, name){
				this.$emit('renameItem', fid, name);
			},
			itemClick(fid, level){
				this.$emit('clickItem', fid, level);
			},
			onClick(fid, level){
				if(this.data.children) this.expand = !this.expand;
				this.$emit('clickItem', fid, level);
			},
			onRemove(fid, name){
				this.$emit('removeItem', fid, name);
			},
		}
	}
</script>

<style>
	.dy-folder-item{
		display:flex;
		flex-direction: row;
		justify-content: space-between;
		width:100%;
		height:35px;
		line-height:25px;
		border-radius:17.5px;
		color:#dfdfdf;
		/* margin-bottom:5px; */
		padding:5px 10px;
		box-sizing:border-box;
		overflow:hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		cursor:pointer;
	}
	.dy-folder-item:hover{
		background-color:#111;
		color:#fff;
	}
	.folderBorder{
		border-top:1px solid #202023;
	}
	.dy-folder-item .dy-icon:before{
		color:#3f3f3f;
	}
	.dy-folder-item:hover .icon-folder:before{
		color:rgb(125, 211, 252);
	}
	.dy-folder-item .dy-icon{
		transition:transform 0.3s;
		width:25px;
		height:25px;
		line-height:25px;
		text-align:center;
	}
	.iconExpand{
		transform:rotateZ(180deg);
	}
	.folderExpand{
		background-color:rgba(255,255,255,0.02);
		border-radius:15px;
		border:0;
	}
	.iconActive:before{
		color:rgb(99, 120, 231) !important;
	}
	.folder-name{
		height:25px;
		line-height:25px;
		color:#dfdfdf;
		overflow:hidden;
		text-overflow: ellipsis;
	}
	.folder-rename{
		display:none !important;
	}
	.folder-rename:hover:before{
		color:#efefef;
	}
	.dy-folder-item:hover .folder-rename,
	.dy-folder-item:hover .folder-rename{
		display:inline-block !important;
	}
	.folder-name-input{
		background-color:transparent !important;
		height:25px !important;
		line-height:25px !important;
	}
</style>